import { finish, error } from '../../../modules/customers/actions/play-break';

import api from '../../../api';

export function request(dispatch, { id, days }) {
    api.post('/customers/' + id + '/play-break', { days }).then(
        () => api.get('/customers/' + id).then(
            (customer) => dispatch(finish(id, customer)),
            () => dispatch(finish(id))
        ),
        ({ errors }) => dispatch(error(id, errors))
    );
}
